import _some from 'lodash/some';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';

const isPreviousSelectedColorEmptyOrUnavailable = (prevSelectedColor, colors) => (
  _isEmpty(prevSelectedColor)
|| (colors.length > 0 && !_some(colors, (cc) => cc.id === (prevSelectedColor.id || prevSelectedColor.choiceId))));

const isPreviousSelectedColorAvailable = (prevSelectedColor, colors) => (
  prevSelectedColor
  && colors && colors.length > 0
  && _find(colors, (cc) => cc.id === (prevSelectedColor.id || prevSelectedColor.choiceId)));

const isNewColorSelectedByUser = (prevSelectedColor, newSelectedColor) => (
  prevSelectedColor
  && newSelectedColor
  && prevSelectedColor.id !== newSelectedColor.id
);

export {
  isPreviousSelectedColorEmptyOrUnavailable,
  isPreviousSelectedColorAvailable,
  isNewColorSelectedByUser,
};
